import React from "react";
import { Card, CardContent } from "@repo/ui";
import { Link } from "react-router-dom";
import { isOperationAllowed } from "utils/helper";
import Layout from "components/layout";
import { CashierActionList } from "utils/constant";

export default function Dashboard() {
  return (
    <Layout>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(360px,1fr))] p-8 gap-6">
        {CashierActionList.map((item) => (
          <DashboardCard {...item} key={item.label} />
        ))}
      </div>
    </Layout>
  );
}

function DashboardCard({
  label,
  icon: Icon,
  path,
  permission,
}: {
  label: string;
  icon?: () => JSX.Element;
  path: string;
  permission: string;
}) {
  return (
    <Link
      to={path}
      className={
        isOperationAllowed(permission)
          ? ""
          : "pointer-events-none cursor-not-allowed opacity-70"
      }
    >
      <Card className="shadow-md">
        <CardContent className="p-4 flex justify-between">
          <span className="block min-h-[40px] text-secondary font-semibold text-lg">
            {label}
          </span>
          <div className="flex justify-center items-center bg-secondary text-primary rounded-md w-[70px] h-[70px]">
            {Icon ? <Icon /> : null}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
